import React, { useCallback, useEffect, useState, useTransition } from 'react'
import { AUTH_KEY } from '../services/constants';
import ProfileService from '../services/profile.service';
import AuthService from '../services/auth.service';
import { useApp } from '../hooks/useApp';
import { PreLoader } from '../components/PreLoader/PreLoader';
export const AuthContext = React.createContext({

})
export const AuthProvider = ({ children }) => {
    const {exceptionHandler} = useApp();
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const login = (values, actions, callback = (user) => {}) => {
        AuthService.login(values.email, values.password).then((data) => { 
            localStorage.setItem(AUTH_KEY, JSON.stringify(data));
            ProfileService.profile().then((userData) => {
                setUser(userData);    
                callback(userData);
            })
            
        })
        .catch((error) => exceptionHandler(error, actions))
        .finally(() => actions.setSubmitting(false));
    }
    const logout = (callback = () => {}) => {
        setUser(null);
        localStorage.removeItem(AUTH_KEY);
        callback();

    }
    const fetchData = useCallback(async () => {
        if(user) return;
        if(localStorage.getItem(AUTH_KEY)){
            const auth = JSON.parse(localStorage.getItem(AUTH_KEY));
            if(auth) {
                const userData = await ProfileService.profile();
                setUser(userData);
            }
        }
        setIsLoading(false);
    }, [user]);
    useEffect(() => {
        fetchData()
    }, [fetchData])
    return (
      <AuthContext.Provider value={{
            user,
            login,
            logout
        }}>
            <PreLoader show={isLoading} />
            {!isLoading && children}
      </AuthContext.Provider>
    );
  };